import { SVGProps } from 'react';

export const Fantastic = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 104 104"
        {...props}
    >
        <path
            fill="#4A9B41"
            d="M51.958 8.667c-23.92 0-43.29 19.37-43.29 43.333 0 23.963 19.37 43.333 43.29 43.333 23.92 0 43.377-19.37 43.377-43.333 0-23.963-19.414-43.333-43.377-43.333Zm.043 78c-19.153 0-34.666-15.514-34.666-34.667 0-19.153 15.513-34.667 34.666-34.667 19.154 0 34.667 15.514 34.667 34.667 0 19.153-15.513 34.667-34.667 34.667Zm4.334-43.594 4.593 4.594 4.593-4.594 4.594 4.594 4.593-4.594-9.187-9.186-9.186 9.186Zm-17.854 0 4.594 4.594 4.593-4.594-9.187-9.186-9.186 9.186 4.593 4.594 4.593-4.594Zm13.52 32.76c10.097 0 18.677-6.326 22.144-15.166H29.858c3.467 8.84 12.047 15.166 22.143 15.166Z"
        />
    </svg>
);
